import React from 'react'
import { connect } from 'react-redux';
import Month from '../calendar/Month';
import PickColor from '../input/PickColor';
import Comparison from './Comparison';
import BuyButton from '../button/BuyButton';
import foldedImage from '../../images/kv_folded_fully_compressed.webp'
import Footer from './Footer';

const Home = ({ date }) => {
  const { dates } = date;
  return ( 
    <div id="home">
      <header>
        <h1><a href="https://carpe-diem-calendar.vodang.com"><span id="home-link">Carpe Diem Calendar</span></a></h1>
      </header>
      <div className="copy">
        <h2>Seize the day. Every day.</h2>
        <p>
          Carpe Diem Calendar is a productivity calendar, delivered as a PDF for you to print out at home, on an A4 sheet of paper.
          <br /><br />
          With strategic placement, such as resting it on either your bedside table or work desk, 
          it’ll be easy for you reflect and plan for the days ahead.
        </p>
      </div>
      <div id="folded-image">
        <img src={foldedImage} alt=""/>
      </div>
      <div className="copy">
        <h2>Set goals. Smash goals.</h2>
        <p>
          Print it out, write down your goals, and then at the end of the day—reflect.
          <br /><br />
          If you made progress on a goal, you'll ⭕ the day. If you didn’t make any progress, then ❌ the day. That's it.
        </p>
      </div>
      <Comparison dates={dates} />
      <div className="copy">
        <h2>Free delivery. No promo code required.</h2>
        <ol>
          <li>Select your Carpe Diem Calendar, and then your browser will begin to download it as a PDF.</li>
          <li>Print it out, then fold your calendar along the light grey lines.</li>
          <li>Fill in your goals for the month (we suggest min. 1, max. 3).</li>
          <li>End of the day. Circle over the day if you made progress towards one of the goals. Cross the day if you didn’t.</li>
        </ol>
      </div>
      <div className="preview">
        <div className="month-preview">
          <Month date={dates[0]}/>
        </div>
        <div id="colourways" className="copy">
          <h2>Colourways. For days.</h2>
          <p>Each colourway has been designed with a main colour and a complementary colour of a lighter shade.</p>
          <PickColor />
          <BuyButton />
        </div>
      </div>
      <div className="copy">
        <h2>Prefer a digital solution?</h2>
        <p>Meet the simple and powerful habit tracker: <a href="https://carpe-diem.vodang.com" target="_blank">Carpe Diem</a></p>
        <p>Designed as a progressive web app, you can save "Carpe Diem" to your smartphone homescreen for convenient access.</p>
        <p>It's free to use, you can track habits both weekly and monthly, and you can even label habits as either positive or negative.</p>
        <p>What are you waiting for? <a href="https://carpe-diem.vodang.com" target="_blank">Carpe Diem</a></p>
      </div>
      <Footer />
    </div>
   );
}

const mapStateToProps = state => {
  return {
    date: state.date,
  }
}

export default connect(mapStateToProps)(Home);